export default () => {
  const titlesBullet = document.querySelectorAll('.Swiper__TitleBullet');
  // const arrowsVerticalSlider = document.querySelectorAll('.Swiper--Vertical .Swiper__Arrow');
  if(titlesBullet){
    titlesBullet.forEach(titleBullet => {
      // if(arrowsVerticalSlider){
      //   arrowsVerticalSlider.forEach(arrow => {
      //     arrow.addEventListener('click', () => {
      //       titlesBullet.forEach(title => { 
      //         console.log(title)
      //         if(title.classList.contains('swiper-pagination-bullet-active')){
      //           title.classList.add('fade-in-left');
      //         }
      //       });
      //       titleBullet.classList.remove('fade-in-left');
      //     });
      //   });
      // }

      titleBullet.addEventListener('click', () => { 
        titlesBullet.forEach(title => { 
          if(title.classList.contains('swiper-pagination-bullet-active')){
            title.classList.remove('fade-in-left');
          }
        });
        titleBullet.classList.add('fade-in-left');
      })
      
    });

  }


}
